import { type ExtractPropTypes, type PropType } from 'vue'
import {
  type PopupPriceGroupDisplayType,
  type PriceChooseOption,
  type PriceGroupModel,
  type PriceGroupNameValue
} from './types'

export const defaultProps = {
  showConfirmButton: Boolean,
  showCancelButton: Boolean,
  title:{
    type: String,
    default: ''
  },
  confirmButtonText: {
    type: String,
    default: 'OK'
  },
  // 显示原因
  reasonCode:String,
  cancelButtonText: {
    type: String,
    default: 'Cancel'
  },
  type: {
    type: String as PropType<PriceChooseOption>,
    default: 'productSpec'
  },
  value: {
    type: Object as PropType<PriceGroupNameValue>,
    default: {} as PriceGroupNameValue
  },
  displayType: {
    type: String as PropType<PopupPriceGroupDisplayType>,
    default: 'select'
  },
  message: String,
  switchBlankValue: {
    type:Boolean,
    default:false,
  },
  priceGroupList: {
    type: Array as PropType<PriceGroupModel[]>,
    default: [] as PriceGroupModel[]
  }
}
export type PoupPriceGroupOption = ExtractPropTypes<typeof defaultProps>
